import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import { getCalendarGroupKey } from 'owa-calendar-cache';

export default function isCreatingCalendarForCalendarGroup(
    scenarioId: CalendarPickerScenarioId,
    userIdentity: string,
    calendarGroupId: string
): boolean {
    if (!calendarGroupId) {
        return false;
    }

    return (
        getCalendarPickerStore(scenarioId).newCalendarInCalendarGroup ===
        getCalendarGroupKey(userIdentity, calendarGroupId)
    );
}
